import React, { useState, useContext, useEffect } from "react";
import PatientDetails from "../../Components/PatientInformation";
import {
  HTTPResponse,
  SideMenuItems,
  ToastMessageType,
  Values,
} from "../../Helpers/Enums";
import SideBarMenu from "../../Components/SideBarMenu";
import { CommonError_Msgs, CommonMsgs } from "../../Helpers/HelperText";
import { PatientService } from "../../WebApiServices/Patient.service";
import {
  AddLocalStorageData,
  GetLocalStorageData,
  RemoveLocalStorageData,
  toggleSidebar,
} from "../../Helpers/Utilities";
import { AppContext } from "../../Contexts/AppContextProvider";
import { useNavigate, useSearchParams } from "react-router-dom";
import SaveAndNavigate from "../../Components/SaveAndNavigate";

const ValidateSubmit = () => {
  const [searchParams] = useSearchParams();
  const part = parseInt(searchParams.get("part"));

  const { ShowToast, ToggleLoader, ShowActionPopUp, HandleSessionTimeout, isSideMenuActive, setisSideMenuActive} =
    useContext(AppContext);

  const pid = GetLocalStorageData("patientId") ?? 0;
  const userId = GetLocalStorageData("userId") ?? 0;

  let patientData = GetLocalStorageData("patient");
  patientData = patientData && JSON.parse(patientData);
  const locked = patientData?.locked ?? false;
  const submit = patientData?.submit ?? 0;
  let part2locked = patientData?.part2locked ?? false;
  const part2submit = patientData?.part2submit ?? 0;

  const [showSubmitBtn, setShowSubmitBtn] = useState(false);

  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  /* <summary>
    date: 07-11-2023
    Name: AP
    description: Display submit button if patient ready to be locked
    <summary>*/
    useEffect(() => {
    const FetchData = async () => {
      //if (isEligible) //not reqd as eligiblity check is done in service

      // ToggleLoader(true)
      if (!locked || part === 1) {
        await SetPatientSubmitValue(1);
        setIsLoading(false);
      } else if ((locked && !part2locked) || part === 2) {
        await SetPatientSubmitValue(2);
        setIsLoading(false);
      }  
      else {
        setShowSubmitBtn(false);
        setIsLoading(false);
      }
      // ToggleLoader(false)
      //setIsLoading(false)
      //await AreAllFormsComplete();
    };
    FetchData();

    //if (submit === 1) {
    //FetchData();
    // } else
    //    setShowSubmitBtn(false);
  }, [submit, locked]);

  /* <summary>
    date: 09-11-2023
    Name: AP
    description: Sets the patient submit value to 1 only if Eligible
    <summary>*/
  const SetPatientSubmitValue = async (partId) => {
    try {
      const payload = {
        pid: pid,
        userId: userId,
        partNo: partId
      };
      ToggleLoader(true);
      const response = await PatientService.SetPatientSubmitValue(payload);
      ToggleLoader(false);
      if (response?.status === HTTPResponse.OK) {
        // Set Patient Submit Value in LS
        const ptArr = { ...patientData };
        ptArr.submit = partId === 1 ? response?.data : partId === 2 ? 2 : 0;
        ptArr.part2submit = partId === 2 ? response?.data : 0;

        AddLocalStorageData("patient", JSON.stringify(ptArr));
        if (locked && response?.data === Values.value2) setShowSubmitBtn(false);
        if (response?.data <= 1) await AreAllFormsComplete(partId);
        else setShowSubmitBtn(false);
      } else {
        if (response?.status === HTTPResponse.Unauthorized) {
          HandleSessionTimeout();
        } else throw response.error;
      }
    } catch {
      ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
    }
  };

  const AreAllFormsComplete = async (partId) => {
    try {
      //const incompletePageIdsArr = []
      // if (submit === 1) {
      ToggleLoader(true);
      const validMenuItems = await PatientService.GetPatientConfigData(pid); //patient config data
      ToggleLoader(false);
      const { status } = validMenuItems;
      if (status !== HTTPResponse.OK) {
        if (status === HTTPResponse.Unauthorized) {
          HandleSessionTimeout();
        }
      } else {
        const { data } = validMenuItems;

        if (validMenuItems != null) {
          const { item1, item2, item3 } = data;
          let allFormsAreComplete = false;
          if(partId === 1)
          {
          if (item1 != null && item1.filter(i => i.part1 === true).length > 0) {
            let listtofilter = item1.filter(i => i.part1 === true);
            allFormsAreComplete = listtofilter.every(item => !item.incomplete);
          }
        }
        else if(partId === 2)
          {
          if (item1 != null && item1.filter(i => i.part2 === true).length > 0) {
            let listtofilter = item1.filter(i => i.part2 === true);
            allFormsAreComplete = listtofilter.every(item => !item.incomplete);
          }
        }

          if (allFormsAreComplete && item2 != null && item2.length > 0) {
            allFormsAreComplete = item2.every((a) => !a.incomplete);
          }
          if (allFormsAreComplete && item3 != null && item3.length > 0) {
            allFormsAreComplete = item3.every((a) => !a.incomplete);
          }
          if (allFormsAreComplete) {
            setShowSubmitBtn(true);
          }
        }
        // } else
        //    setShowSubmitBtn(false)
      }
    } catch { }
  };

  const HandleSubmit = async () => {
    try {
      const payload = {
        pid: pid,
        userId: userId,
        partNo: (!locked) ? 1 : (locked && !part2locked) ? 2 : 0
      };
      
      ToggleLoader(true);
      const response = await PatientService.LockPatient(payload);
      ToggleLoader(false);
      if (response?.status === HTTPResponse.OK) {
        // Set Patient Locked Status in LS
        //submit=2 when patient is locked
        const ptArr = payload.partNo === 1 ? { ...patientData, locked: response?.data, submit: 2 } : { ...patientData, locked: true, part2locked: response?.data, submit: 2 };
        AddLocalStorageData("patient", JSON.stringify(ptArr));

        if(payload.partNo === 2)
          part2locked = response?.data;

        ShowToast(CommonMsgs.SubmitSuccess, ToastMessageType.Success);
        if(part === 1) 
          navigate("/NonMDETreatment")
      } else {
        if (response?.status === HTTPResponse.Unauthorized) {
          HandleSessionTimeout();
        } else throw response.error;
      }
    } catch {
      ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
    }
  };
  const ShowAlertBox = async () => {
    let msgBody = part === 1 ? "By selecting “OK”, all Part 1 forms for this patient will be locked and you will be prevented from making further changes to Part 1 data elements." : "Submitting this patient chart will prevent you from making further changes to the records"; 
    const choice = await ShowActionPopUp(
      "Alert",
      msgBody,
      "Ok" //Confirm button text
    );
    if (!choice) {
      return;
    } else {
      HandleSubmit();
    }
  };
    const AddNew = () => {
        debugger;
    RemoveLocalStorageData("patientId");
        RemoveLocalStorageData("patient");
        const ptArr = {
            canEdit: true
        };
        AddLocalStorageData("patient", JSON.stringify(ptArr));
    return navigate("/AbbreviationList");
  };
  const NavigateToDashboard = () => {
    navigate("/ManagePatients");
  };
  return (
    <>
      <section className="survey-patient-details-section ">
        <div className="row">
          <PatientDetails />
        </div>
      </section>
      <section className="main-survey-section short-page main-survey-button">
        <div >
          <SideBarMenu activePageId={(part === 2) ? SideMenuItems.ValidateSubmit2 : SideMenuItems.ValidateSubmit1} />
          <>
            <button
              className={isSideMenuActive ? "openbtn" : "openbtn active"}
              onClick={() =>
                toggleSidebar(isSideMenuActive, setisSideMenuActive)
              }
            >
              <i
                id="arrowNavigation"
                className="fa fa-arrow-left"
                aria-hidden="true"
              ></i>
            </button>
          </>

          <div className="col-pad-left" id="main">
            <div className="survey-section-content" id="contentsec">
              <div className="survey-section-content-header">
                {isLoading ? (
                  <></>
                ) : //showSubmitBtn === true ? <h4>Submit</h4> :
                  part2locked ? (
                    <h4>SUBMITTED</h4>
                  ) : (
                    <h4>VALIDATE & SUBMIT</h4>
                  )}
              </div>

              <div
                className={
                  locked
                    ? "survey-introduction-section Survey-footer-section"
                    : "survey-introduction-section Survey-footer-sectionSave"
                }
              >
                <div className="survey-introduction-content survey_Validate_submit">
                  <div className="instructions">
                                      {isLoading ? (
                                          <></>
                                      ) : (part2locked && part === 2) ? ( //&& submit === 2 //Patient is already submitted
                                          <center
                                              style={{ paddingTop: "100px", fontSize: "large" }}
                                          >
                                              Thank you for your participation. Patient has been
                                              successfully submitted. To add a new patient, please
                                              click on ‘Add new patient’ and to return to the
                                              dashboard, click ‘Go to Patients.
                                          </center>
                                          ) : ((locked && part === 1) || (locked && Number.isNaN(part))) ? ( //&& submit === 2 //Patient is already submitted
                                          <center
                                              style={{ paddingTop: "100px", fontSize: "large" }}
                                          >
                                              Thank you for your participation. Patient ‘Part 1’ data has been
                                              successfully submitted. Please proceed to submit ‘Part 2’ data.
                                          </center>
                                      ) : showSubmitBtn === true ? ( //Patient is ready to be submitted n locked
                                          <center
                                              style={{ paddingTop: "100px", fontSize: "large" }}
                                          >
                                              Please review the patient information you have entered.
                                              Click Submit once you are ready to finish this chart.
                                              Please note that once you submit the chart, no further
                                              changes can be made.
                                          </center>
                                      ) : (
                                          //Patient has some incomplete forms to be filled
                                          <center
                                              style={{ paddingTop: "100px", fontSize: "large" }}
                                          >
                                              Some values have been left blank in the assessment form.
                                              Please visit each page highlighted in{" "}
                                              <span style={{ color: "red" }}>red</span> to the left,
                                              and click Submit.
                                          </center>
                                      )}
                  </div>
                </div>
              </div>

              <div className="survey-section-content-foot">
                {(!part2locked && showSubmitBtn) && (
                  <a
                    className="btn save-btn"
                    onClick={ShowAlertBox}
                    style={{ fontWeight: "600", fontSize: "large" }}
                  >
                    Submit
                  </a>
                )}
                {(part2locked && part === 2) && (
                  <>
                    <a
                      className="btn save-btn"
                      onClick={AddNew}
                      style={{
                        fontWeight: "600",
                        fontSize: "large",
                        marginRight: "22px",
                      }}
                    >
                      Add new patient
                    </a>
                    <a
                      className="btn save-btn"
                      onClick={NavigateToDashboard}
                      style={{ fontWeight: "600", fontSize: "large" }}
                    >
                      Go to Patients
                    </a>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ValidateSubmit;
